import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { BaseComponent } from './base/base.component';
import { RouterModule } from '@angular/router';
import {ToastModule} from 'primeng/toast';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import{CallCenterModule} from '../call-center/call-center.module'
import {SidebarModule} from 'primeng/sidebar';
import { ClickOutsideModule } from 'ng-click-outside';
import {DropdownModule } from 'primeng/dropdown';
import {TableModule } from 'primeng/table';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import {CheckboxModule} from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CallCenterInboundCallModule } from '../call-center/call-center-inbound-call/call-center-inbound-call/call-center-inbound-call.module';
import { CallCenterDialerModule } from '../call-center/call-center-dailer/call-center-dialer/call-center-dialer.module';
import { AgentLeadNotificationComponent } from './agent-lead-notification/agent-lead-notification.component';
import { AgentLeadChatDetailComponent } from './agent-lead-chat-detail/agent-lead-chat-detail.component';
import { WhatsAppRequestComponent } from './whatsapp-request/whatsapp-request.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FeedbackRequestComponent } from './feedback-request/feedback-request.component';
import { FeedbackNotificationComponent } from './feedback-notification/feedback-notification.component';
import { FeedbackAgentChatComponent } from './feedback-agent-chat/feedback-agent-chat.component';

//const config: SocketIoConfig = { url: environment.socketApiUrl, options: {} };

@NgModule({
  declarations: [HeaderComponent, FooterComponent, SidenavComponent, BaseComponent, AgentLeadNotificationComponent, AgentLeadChatDetailComponent, WhatsAppRequestComponent, FeedbackComponent, FeedbackRequestComponent, FeedbackNotificationComponent, FeedbackAgentChatComponent],
  imports: [
    CommonModule,
    RouterModule,
    ToastModule,
    TableModule,
    TooltipModule.forRoot(),
    OverlayPanelModule,
    CallCenterInboundCallModule,
    CallCenterDialerModule,
    SidebarModule,
    ClickOutsideModule,
    DropdownModule,
    //SocketIoModule.forRoot(config),
    CheckboxModule,
    PopoverModule.forRoot(),
    ModalModule.forRoot(),
    FormsModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    SidebarModule,
    AgentLeadNotificationComponent,
    AgentLeadChatDetailComponent,
    FeedbackNotificationComponent,
    //SocketIoModule
  ]
})
export class BaseModule { }
